export const FACEBOOK_DOMAIN_VERIFICATION = process.env
  .NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION as string;
export const FACEBOOK_PIXEL_ID = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_ID as string;
export const FACEBOOK_PIXEL__PILATES_V2_ID = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_PILATES_V2_ID as string;
export const FACEBOOK_PIXEL_SHORT_ID = process.env
  .NEXT_PUBLIC_FACEBOOK_PIXEL_SHORT_ID as string;
export const GA_ID_V2 = process.env.NEXT_PUBLIC_GA_ID_V2;
export const CLARITY_ID = process.env.NEXT_PUBLIC_CLARITY_ID;
export const PINTEREST_ID = process.env.NEXT_PUBLIC_PINTEREST_ID;
export const PINTEREST_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_PINTEREST_ACCOUNT_ID;
export const TWITTER_ID = process.env.NEXT_PUBLIC_TWITTER_PIXEL_ID;
export const TIK_TOK_PIXEL = process.env.NEXT_PUBLIC_TIK_TOK_PIXEL_ID;
export const TIK_TOK_PIXEL_PILATES =
  process.env.NEXT_PUBLIC_TIK_TOK_PIXEL_ID_PILATES;
export const APPLOVIN_PIXEL_ID = process.env.NEXT_PUBLIC_APPLOVIN_PIXEL_ID;
export const APPLOVIN_ITEM_BRAND = 'Youth';
export const APPLOVIN_ITEM_CATEGORY_ID = 2915;
export const APPLOVIN_ITEM_IMAGE_URL =
  'https://s.youth-app.com/images/logo.png';
export const APPLOVIN_ITEM_LIST_ID = 'subscription_plans';

export const ANALYTICS_ENDPOINT = process.env
  .NEXT_PUBLIC_API_ANALYTICS_ENDPOINT as string;
export const ANALYTICS_ENDPOINT_V2 =
  process.env.NEXT_PUBLIC_API_ANALYTICS_ENDPOINT_V2;

export const FACEBOOK_IDS = new Set(
  [
    FACEBOOK_PIXEL_ID,
    FACEBOOK_PIXEL_SHORT_ID,
    FACEBOOK_PIXEL__PILATES_V2_ID,
  ].filter(Boolean) as string[],
);

export const PIXEL_VARIANT_MAP = new Map([
  ['WP20FBShrtPix', FACEBOOK_PIXEL_SHORT_ID],
  ['WPShrt_tr_m1', FACEBOOK_PIXEL_SHORT_ID],
  ['WPShrt_tr_m2', FACEBOOK_PIXEL_SHORT_ID],
  ['PilatesVideo', FACEBOOK_PIXEL__PILATES_V2_ID],
  ['jw2_fb_tr', FACEBOOK_PIXEL_SHORT_ID],
]);

export const FACEBOOK_BACKEND_VARIANTS_MAP = new Map<string, string>([
  [FACEBOOK_PIXEL_ID, 'youth'],
  [FACEBOOK_PIXEL__PILATES_V2_ID, 'pilates_creo'],
  [FACEBOOK_PIXEL_SHORT_ID, 'Youth_September_2025'],
]);

export const PINTEREST_EVENT_NAME_TO_RIGHT_CONVENTION = {
  AddToCart: 'add_to_cart',
  Checkout: 'checkout',
  Custom: 'custom',
  Lead: 'lead',
  PageVisit: 'page_visit',
  Search: 'search',
  Signup: 'signup',
  ViewCategory: 'view_category',
  WatchVideo: 'watch_video',
};

export const TP_FACEBOOK_EVENT_NAMES = [
  'AddToCart',
  'StartTrial',
  'SecondScreen',
  'AddPaymentInfo',
  'ViewContent',
  'CompleteRegistration',
  'InitiateCheckout',
  'Subscribe',
  'Purchase',
  'Lead',
] as const;

export const TP_APPLOVIN_EVENT_NAMES = [
  'page_view',
  'view_item',
  'add_to_cart',
  'begin_checkout',
  'add_payment_info',
  'purchase',
  'sign_up',
  'login',
  'generate_lead',
  'search',
  'subscribe',
  'remove_from_cart',
  'view_cart',
] as const;
